/*
 * Copyright © 2021 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import { withRouter } from "react-router-dom";
import { OrderTrackingMap } from '../components/OrderTrackingMap';
import { OrderTracking } from '../models/order-tracking';
import { OrderSubHeader } from '../components/OrderSubHeader';
import { FooterWithLinks } from '../components/FooterWithLinks';
import { StoreService } from '../store.service';
import i18n from '../getText';
import { Preloader } from '../components/Preloader';
import { GOOGLE_MAP_URL } from '../constants';
import { OrderState, OrderStatus } from '../types';
import { TimeLine } from '../components/TimeLine';
import { getETAmin } from "../helpers";

interface Params {
  storeService: StoreService,
  history: any
}

class PageState {
  error: boolean = false;
  message: string = '';
  loaded: boolean = false;
  pickUpETA: number = 0;
  dropOffETA: number = 0;
  orderTracking: OrderTracking = new OrderTracking();
}

class OrderTrackingPage extends React.Component<Params, PageState> {

  constructor(props) {
    super(props);

    this.state = new PageState();

  }

  componentDidMount() {
    this.props.storeService.load()
      .then((orderTracking: OrderTracking) => {

        if (orderTracking.state === OrderState.WAIT_CUSTOMER_LOCATION) {
          this.props.history.replace({pathname: '/select-address'});
        }
        this.setState({orderTracking});

        const timeItemPickUp = orderTracking.timeline.find(t => t.type === OrderStatus.AT_PICK_UP);
        if (timeItemPickUp && timeItemPickUp.estimatedDate) {
          this.setState({pickUpETA: getETAmin(timeItemPickUp.estimatedDate)});
        }

        const timeItemDropOff = orderTracking.timeline.find(t => t.type === OrderStatus.AT_DROP_OFF);
        if (timeItemDropOff && timeItemDropOff.estimatedDate) {
          this.setState({dropOffETA: getETAmin(timeItemDropOff.estimatedDate)});
        }

      })
      .catch(error => this.setState(error))
      .then(() => this.setState({loaded: true}));

  }


  render() {

    return (
      <article className="site_wrapper">
        <header className="order_header">
          <div className="container">

            <p className="heading ta-c mb-0">
              {i18n.pgettext('OrderTrackingPage', 'Order Tracking')}
            </p>

            {this.state.loaded && !this.state.error && <OrderSubHeader
              number={this.state.orderTracking.number}
              merchant={this.state.orderTracking.merchant}
              totalCost={this.state.orderTracking.totalCost}/>}
          </div>
        </header>

        {this.state.loaded && !this.state.error && <main className="content_wrapper flex_content">
          <div className="map flex_content-inner">
            <OrderTrackingMap
              pickUpLocation={this.state.orderTracking.pickUpGeoPoint}
              pickUpETA={this.state.pickUpETA}
              dropOffETA={this.state.dropOffETA}
              dropOff={this.state.orderTracking.dropOffAddress}
              googleMapURL={GOOGLE_MAP_URL}
              loadingElement={<div style={{height: `40vh`}}/>}
              containerElement={<div style={{height: `40vh`}}/>}
              mapElement={<div style={{height: `100%`}}/>}
            />
          </div>
          <div className="container flex_content-inner">
            <TimeLine timeline={this.state.orderTracking.timeline}
                      pickUpAddress={this.state.orderTracking.pickUpAddress}
                      dropOffAddress={this.state.orderTracking.dropOffAddress}/>
          </div>
        </main>}

        {this.state.loaded && this.state.error && <main className="content_wrapper">
          <p className="error_box">{this.state.message}</p>
        </main>}

        {!this.state.loaded && <Preloader/>}

        <FooterWithLinks/>
      </article>
    );


  }
}

export default withRouter(OrderTrackingPage);



// WEBPACK FOOTER //
// ./src/app/pages/OrderTrackingPage.tsx